<div [ngStyle]="{ 'width': width, 'height': height }" class="smart-image-container">
  <div class="spinner-container">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
  <img [src]="url" class="image" [ngStyle]="{'width': width, 'height': height}" loading="lazy">
  <!--  <div class="image" [ngStyle]="{ 'background-image': 'url(' + url + ')', 'background-size': type, 'background-position': 'center center',-->
  <!--  'background-repeat': 'no-repeat', 'width': 'calc(' + width + ' + 4px)', 'height': 'calc(' + height + ' + 4px)' }"></div>-->
</div>
